import formatting from './formatting';
import introduction from './introduction';
import language from './language';
import react from './react';

export default {
  introduction,
  language,
  formatting,
  react,
};
